var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalanderCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87012 2.00003V4.85003M11.5701 2.00003V4.85003M15.1326 10.55V4.85003C15.1326 4.4721 14.9825 4.10964 14.7152 3.8424C14.448 3.57516 14.0856 3.42503 13.7076 3.42503H3.73262C3.35468 3.42503 2.99223 3.57516 2.72499 3.8424C2.45775 4.10964 2.30762 4.4721 2.30762 4.85003V14.825C2.30762 15.203 2.45775 15.5654 2.72499 15.8327C2.99223 16.0999 3.35468 16.25 3.73262 16.25H9.43262M2.30762 7.70003H15.1326M11.5701 14.825L12.9951 16.25L15.8451 13.4",
    stroke: "#1EF35E",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderCheckGreen);
export default __webpack_public_path__ + "static/media/calander-check-green.2da740b4c116d5e55c9bb7ffec09df70.svg";
export { ForwardRef as ReactComponent };